<template>
  <v-card>
    <v-container fluid>
      <v-row dense class="text-h5">
        <v-col> {{ cid.code }} - {{ cid.description }} </v-col>

        <v-spacer />

        <v-col cols="auto">
          <authorization
            permissionKey="configuration_diagnostic_hypothesis"
            can="save"
            v-slot:default="{ authorization }"
          >
            <v-dialog v-model="dialog" max-width="700px" @click:outside="close">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-if="authorization" class="mr-2" v-bind="attrs" v-on="on">
                  eva-edit-outline
                </v-icon>
              </template>

              <v-card>
                <v-card-title>
                  <span class="headline">Editar Cid</span>
                </v-card-title>

                <v-card-text>
                  <v-container fluid>
                    <v-row dense>
                      <v-col cols="4">
                        <v-text-field
                          outlined
                          dense
                          v-model="cid.code"
                          label="Código"
                          :hide-details="!errors.cid"
                          :error-messages="errors.cid"
                        />
                      </v-col>

                      <v-col>
                        <v-text-field
                          outlined
                          dense
                          v-model="cid.description"
                          label="Descrição"
                          :hide-details="!errors.cid"
                         :error-messages="errors.cid"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancelar
                  </v-btn>

                  <v-btn color="blue darken-1" text @click="save">
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </authorization>

          <authorization
            permissionKey="configuration_diagnostic_hypothesis"
            can="delete"
            v-slot:default="{ authorization }"
          >
            <v-icon v-if="authorization" @click="deletePresentation">
              eva-trash-outline
            </v-icon>
          </authorization>
        </v-col>
      </v-row>

      <v-divider />

      <v-row dense>
        <v-col>
          <CidItemTable :cid="cid" :refreshList="refreshList" />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import CidItemTable from "@/components/config/diagnostic_hypothesis/cid/item/cid_item_table.vue";

  export default {
    name: "CidListItem",
    props: {
      cid: Object,
      refreshList: Function,
    },
    components: {
      CidItemTable,
    },
    data() {
      return {
        errors: {},
        dialog: null,
      };
    },
    methods: {
      deletePresentation() {
        if (confirm("Você realmente deseja deletar esse facilitador?")) {
          this.apolloMutate({
            mutation: require("@/graphql/diagnostic_hypothesis/delete_cid.gql"),
            variables: {
              cidId: this.cid.id,
            },
          }).then(() => {
            this.refreshList();
            this.$store.dispatch("createNotification", {
              message: "Facilitador deletado com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
      },
      save() {
        if (!this.validate()) return;

        this.apolloMutate({
          mutation: require("@/graphql/diagnostic_hypothesis/save_cid.gql"),
          variables: {
            cidId: this.cid.id,
            code: this.cid.code,
            description: this.cid.description,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
      validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        let code = this.cid.code;
        if (this.lodash.isEmpty(code?.trim())) {
          this.errors.cid = errorMsg;
        }

        let description = this.cid.description;
        if (this.lodash.isEmpty(description?.trim())) {
          this.errors.cid = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
    },
  };
</script>

<style lang="sass" scoped></style>
